import { HeroTeaser } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../hooks/useAuth";
import { useEffect } from "react";
import { trackOnStandardError } from "../../adobeTracking/trackers";

export const NotFoundPage = () => {
    const { t } = useTranslation("errors");
    const { auth } = useAuth();
    useEffect(() => {
        trackOnStandardError("Not Found");
    }, []);

    return (
        <>
            {auth.contractID ? (
                <HeroTeaser
                    noImage
                    buttonText={t("notFound.button")}
                    onButtonClick={() => {
                        if (auth.contractID) window.location.href = "?ref_id=" + auth.contractID;
                    }}
                    sub={
                        <>
                            <p>{t("notFound.subtitle")}</p>
                            <p>{t("notFound.subtitle2")}</p>
                            <p>{t("notFound.subtitle3")}</p>
                        </>
                    }
                    title={t("notFound.title")}
                />
            ) : (
                <HeroTeaser
                    noImage
                    sub={
                        <>
                            <p>{t("notFound.subtitle")}</p>
                            <p>{t("notFound.subtitle2")}</p>
                            <p>{t("notFound.subtitle3")}</p>
                        </>
                    }
                    title={t("notFound.title")}
                />
            )}
        </>
    );
};
